import React from 'react';
import { Col, Layout, Row, Typography } from 'antd';
import GreetingsTop from '../../components/menu/greetings-top';
import Modules from '../../components/administration/modules';
import CatalogsModules from '../../components/catalogs';

export default function Catalogs() {
  const { Title } = Typography;
  return (
    <Layout>
      <GreetingsTop />
      <div className="catalog__container">
        <Row className="header-top">
          <Col md={12} xs={24} className="header-top__left">
            <Title
              level={3}
              style={{ top: 0, bottom: 0, height: '78%', margin: 'auto' }}
            >
              Catálogos
            </Title>
          </Col>
        </Row>
      </div>
      <div className="catalog__container">
        <CatalogsModules />
      </div>
    </Layout>
  );
}
